import StockMovement from "@/components/StockMovement";

// Legacy route redirects to Stock Movement page in Purchase mode.
export default function ItemPurchase({ companyContext }) {
  return <StockMovement companyContext={companyContext} initialMode="purchase" />;
}
